import * as yup from "yup"
import type { Media } from "../../types"

export function initialValuesMedia(media?: Media | undefined) {
  if (media) {
    return media
  }
  return {
    title: "",
    description: "",
    media_file: null,
    media_type: "",
  }
}

export function validationSchemaMedia() {
  return yup.object().shape({
    media_file: yup.mixed().required("Campo obbligatorio"),
    media_type: yup.string().required("Campo obbligatorio"),
  })
}
